var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleGreenFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333374 7.00065C0.333374 3.32065 3.32004 0.333984 7.00004 0.333984C10.68 0.333984 13.6667 3.32065 13.6667 7.00065C13.6667 10.6807 10.68 13.6673 7.00004 13.6673C3.32004 13.6673 0.333374 10.6807 0.333374 7.00065ZM2.80006 7.46732L5.19339 9.86065C5.45339 10.1207 5.88006 10.1207 6.13339 9.86065L11.1934 4.80065C11.4534 4.54065 11.4534 4.12065 11.1934 3.86065C10.9334 3.60065 10.5134 3.60065 10.2534 3.86065L5.66672 8.44732L3.74006 6.52732C3.48006 6.26732 3.06006 6.26732 2.80006 6.52732C2.67522 6.65187 2.60506 6.82097 2.60506 6.99732C2.60506 7.17366 2.67522 7.34276 2.80006 7.46732Z",
    fill: "#16D99E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleGreenFilled);
export default __webpack_public_path__ + "static/media/check-circle-green__filled.3eb611cec4f88a0a6bfe35176ae4070e.svg";
export { ForwardRef as ReactComponent };